/**
 * Header Organism
 *
 * Cabeçalho do admin - Mobile first
 */
import React, { useState, useRef, useEffect } from 'react'
import { Bell, Menu } from 'lucide-react'
import useAdminStore from '../../core/admin.store'

export default function Header({ title, subtitle, actions }) {
	const { toggleSidebar } = useAdminStore()
	const [showNotifications, setShowNotifications] = useState(false)
	const notificationRef = useRef(null)

	// Fechar dropdown ao clicar fora
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (notificationRef.current && !notificationRef.current.contains(event.target)) {
				setShowNotifications(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	return (
		<header className="sticky top-0 z-20 bg-base-300 border-b border-base-200">
			<div className="flex items-center justify-between h-14 md:h-16 px-3 md:px-6">
				{/* Left */}
				<div className="flex items-center gap-2 md:gap-4 min-w-0 flex-1">
					<button
						onClick={toggleSidebar}
						className="lg:hidden p-2 hover:bg-base-400 rounded-lg flex-shrink-0"
					>
						<Menu className="w-5 h-5" />
					</button>
					<div className="min-w-0">
						<h1 className="text-base md:text-xl font-semibold text-text truncate">{title}</h1>
						{subtitle && (
							<p className="text-xs md:text-sm text-text-body truncate hidden sm:block">{subtitle}</p>
						)}
					</div>
				</div>

				{/* Right */}
				<div className="flex items-center gap-1 md:gap-3 flex-shrink-0">
					{/* Actions - hidden on very small screens if needed */}
					<div className="hidden sm:flex items-center gap-2">
						{actions}
					</div>
					<div className="relative" ref={notificationRef}>
						<button
							className="relative p-2 hover:bg-base-400 rounded-lg"
							onClick={() => setShowNotifications(!showNotifications)}
						>
							<Bell className="w-5 h-5 text-text-body" />
						</button>

						{/* Dropdown de notificações */}
						{showNotifications && (
							<div className="absolute right-0 mt-2 w-72 md:w-80 bg-base-300 border border-base-200 rounded-lg shadow-lg overflow-hidden">
								<div className="p-3 md:p-4 border-b border-base-200">
									<h3 className="font-semibold text-text text-sm md:text-base">Notificações</h3>
								</div>
								<div className="p-6 md:p-8 text-center">
									<Bell className="w-6 h-6 md:w-8 md:h-8 text-text-muted mx-auto mb-2" />
									<p className="text-text-muted text-xs md:text-sm">
										Nenhuma notificação
									</p>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Mobile actions row - show actions below header on mobile */}
			{actions && (
				<div className="sm:hidden px-3 pb-3 flex items-center gap-2 overflow-x-auto">
					{actions}
				</div>
			)}
		</header>
	)
}
